import muster from '@dbk-legacy/muster';
import { variable, redirectOn } from '@dbk-legacy/muster/helpers';
import { getValues, ref, call } from '@dbk-legacy/muster/utils';
import Guid from '../utils/guid';
import PdfDownload from '../utils/attachment-download';
export default () =>{
  return muster()
    .path('cioinsights.getData', {
      call: async ({ req }, { get, set, call }) => {
        console.log("inside consolidation muster");
        //'cioinsights.roles'

        let [ articleList,
              roleid,
              offSet,
              endOfRecords ] = await getValues(get([ 'cioinsights.articleList',
                                                    'cioinsights.roles',
                                                    'cioinsights.offSet',
                                                    'cioinsights.endOfRecords'
                                                    ]));

        if(endOfRecords == true){
          await set('cioinsights.busy', false);
          return;
        }


        const guidStr = Guid();
        const oReturn = await getValues(get(`roster.data.cioinsights.getData.["${roleid}"].["i${offSet}"]["i4"]["${guidStr}"]`));
        const oResult = JSON.parse(oReturn);


        await set('cioinsights.busy', false);
        await set('cioinsights.offSet', oResult.offSet);
        await set('cioinsights.endOfRecords', oResult.endOfRecords);
        //

        if( articleList != null ){
          const newArticleList = articleList.concat(oResult.cio);
          //
          await set('cioinsights.articleList', newArticleList);
          console.log("cioinsights.getData: add new list set");

        }else{
          await set('cioinsights.articleList', oResult.cio);
          console.log("cioinsights.getData: first set");
        }

      },
    })



    .path('cioinsights.getArticle', {
      call: async ({ req }, { get, set, call }) => {

        await set('cioinsights.articleContent', null);
        await set('cioinsights.attachmentFile', null);
        await set('cioinsights.isLoading', true);
        const guidStr = Guid();
        let articleId =  req.args[0];
        const oReturn = await getValues(get(`roster.data.cioinsights.getArticle.["i${articleId}"]["${guidStr}"]`));
        await set('cioinsights.isLoading', false);
        const oResult = JSON.parse(oReturn);

        await set('cioinsights.articleContent', oResult);

      },
    })

    .path('cioinsights.getAttachment', {
      call: async ({ req }, { get, set, call }) => {
        //
        await set('cioinsights.showPdfModal', false);
        const guidStr = Guid();
        let attachmentId =  req.args[0];
        const oReturn = await getValues(get(`roster.data.cioinsights.getAttachment.["i${attachmentId}"]["${guidStr}"]`));
        
        const oResult = JSON.parse(oReturn);

        const isDownloaded = PdfDownload("cio", oResult.pdfData);

        await set('cioinsights.attachmentFile', oResult);
        await set('cioinsights.showPdfModal', !isDownloaded);
      },
    })

    .path('cioinsights.clearAttachment', {
      call: async ({ req }, { get, set, call }) => {
        await set('cioinsights.attachmentFile', null);
      },
    })


    .path('cioinsights.setBusy', {
      call: async ({ req }, { get, set, call }) => {
        await set('cioinsights.busy', true);
      },
    })



    .path('cioinsights.clearArticle', {
      call: async ({ req }, { get, set, call }) => {
        await set('cioinsights.articleContent', null);
        await set('cioinsights.attachmentFile', null);

      },
    })




    .path('cioinsights.busy', variable(false))

    .path('cioinsights.fileReady', variable(false))
    .path('cioinsights.attachmentFile', variable(null))
    .path('cioinsights.offSet', variable(0))
    .path('cioinsights.endOfRecords', variable(false))
    .path('cioinsights.articleContent', variable())
    .path('cioinsights.articleID', variable())
    .path('cioinsights.roles', variable())
    .path('cioinsights.showPdfModal', variable(false))
    .path('cioinsights.isLoading', variable(false))
    .path('cioinsights.articleList', variable(null));

}

